import { render, staticRenderFns } from "./CommonCodeEditor.vue?vue&type=template&id=2a7af78a&"
import script from "./CommonCodeEditor.vue?vue&type=script&lang=ts&"
export * from "./CommonCodeEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CommonCodeEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports